import React from "react";
import { cn } from "@/lib/utils";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

/** A compact picker that looks like the fields beside it (fag, prisform) – the same control in the dialog and on /maler. */
export function Pick({ value, onChange, options, label, className, testId }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger aria-label={label} className={cn("h-9 rounded-[9px] border-black/[0.1] bg-white px-2.5 text-[13.5px] shadow-none transition-[border-color,box-shadow] focus:border-primary/60 focus:ring-2 focus:ring-primary/15", className)} data-testid={testId}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="rounded-xl border-black/[0.06] shadow-float">
        {options.map(([k, l]) => <SelectItem key={k} value={k} className="cursor-pointer rounded-lg text-[13px]" data-testid={`${testId}-opt-${k}`}>{l}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
